import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listingsApi, type ListingDashboard } from '../../api/listings';

const NAV = [
  { to: '/listings/manager', label: 'Listing manager' },
  { to: '/listings/editor', label: 'Listing editor' },
  { to: '/listings/preview', label: 'Marketplace preview' },
  { to: '/listings/health', label: 'Health dashboard' },
  { to: '/listings/seo', label: 'SEO dashboard' },
  { to: '/listings/compliance', label: 'Compliance dashboard' },
  { to: '/listings/bulk', label: 'Bulk generator' },
  { to: '/listings/compare', label: 'Version comparison' },
  { to: '/listings/templates', label: 'Marketplace templates' },
];

export function ListingsHubPage() {
  const [dashboard, setDashboard] = useState<ListingDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void listingsApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total listings', value: dashboard.total_listings },
        { label: 'Published', value: dashboard.published_listings },
        { label: 'Drafts', value: dashboard.draft_listings },
        { label: 'Suppressed', value: dashboard.suppressed_listings },
        { label: 'Avg health', value: dashboard.avg_health_score?.toFixed(1) },
        { label: 'Avg SEO', value: dashboard.avg_seo_score?.toFixed(1) },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Marketplace Listings</h1>
      <p className="mt-1 text-sm text-slate-600">One product, many marketplace-specific digital twins with AI optimization.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? '—')}</p>
          </div>
        ))}
      </div>
      {dashboard?.by_marketplace && (
        <div className="mt-6 rounded-xl border bg-white p-4">
          <p className="font-medium">By marketplace</p>
          <ul className="mt-2 space-y-1 text-sm">
            {Object.entries(dashboard.by_marketplace).map(([k, v]) => (
              <li key={k}>{k}: {v}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
